var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarSalonScheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 480 570",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "car copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.3725505,43.5866805 C58.4150426,44.1634301 61.4575347,44.451805 64.5000269,44.451805 C67.5425201,44.451805 70.5850133,44.1634299 73.6275066,43.5866798 L73.6275071,43.5866825 C74.7127482,43.3809588 75.7592819,44.0939486 75.9650055,45.1791896 C75.9882839,45.3019886 76,45.4266994 76,45.5516853 L76,54.4059478 C76,55.5105173 75.1045695,56.4059478 74,56.4059478 C73.8861077,56.4059478 73.7724236,56.3962193 73.6601873,56.3768683 C70.6068005,55.8504241 67.5534137,55.587202 64.5000269,55.587202 C61.4466424,55.587202 58.393258,55.8504237 55.3398736,56.376867 L55.3398748,56.3768744 C54.2513615,56.5645483 53.2168073,55.8342736 53.0291333,54.7457602 C53.0097823,54.6335236 53.0000537,54.5198392 53.0000537,54.4059466 L53.0000497,45.5516899 C53.0000497,44.4471182 53.895482,43.5516859 55.0000537,43.5516859 C55.12504,43.5516859 55.2497511,43.563402 55.3725505,43.5866805 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.827539,41.5697055 L35.7534542,40.8337686 C34.926827,40.7477723 34.1869994,41.3481722 34.1010031,42.1747994 C34.0956216,42.2265284 34.0929254,42.2785015 34.0929254,42.3305096 L34.0929254,42.3305096 C34.0929254,43.2525437 33.3454691,44 32.423435,44 L21.6694904,44 C20.7474563,44 20,43.2525437 20,42.3305096 L20,41.7829039 C20,41.0860544 20.3627112,40.439444 20.9573797,40.0761693 L22.1583959,39.3424853 C22.4079361,39.1900447 22.4866509,38.8641749 22.3342103,38.6146347 C22.2380387,38.4572051 22.0668583,38.3611827 21.8823778,38.3611827 L21.8823778,38.3611827 C20.8427692,38.3611827 20,37.5184134 20,36.4788049 L20,30.4292903 C20,29.5994888 20.5124031,28.8558781 21.2878111,28.5603904 L49,18 C39.3477866,28.3722188 34.849123,33.9791027 35.5040091,34.820652 C35.9544486,35.3994809 38.6273716,36.7877769 43.5227781,38.98554 L43.5227955,38.9855013 C44.2055865,39.2920362 44.5106023,40.0940432 44.2040674,40.7768342 C43.9644635,41.3105399 43.4094216,41.6302404 42.827539,41.5697055 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,279 L134,279 M98,279 L82,279 M46.3688488,279 L41.2873563,279 C27.3215351,279 16,267.661351 16,253.674419 L16,221.44186 C16,198.554153 34.5261483,180 57.3793103,180 L174.62069,180 C197.473852,180 216,198.554153 216,221.44186 L216,253.674419 C216,267.661351 204.678465,279 190.712644,279 L185.677173,279",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.992748,86 L18.2795052,86 C8.18401325,86 0,76.3741221 0,64.5 L0,10.75 C0,4.81293894 4.09200663,-1.36424205e-12 9.13975261,-1.36424205e-12 L23,-1.36424205e-12",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9639825,107 L11.7057967,107 C8.00228747,107 5,103.138456 5,98.375 L5,92.625 C5,87.861544 8.00228747,84 11.7057967,84 L23,84",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-6",
    x: 0,
    y: 23,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0,
    y: 48,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-8",
    x: 0,
    y: 52,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.992748,86 L18.2795052,86 C8.18401325,86 0,76.3741221 0,64.5 L0,10.75 C0,4.81293894 4.09200663,-1.36424205e-12 9.13975261,-1.36424205e-12 L23,-1.36424205e-12",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9639825,107 L11.7057967,107 C8.00228747,107 5,103.138456 5,98.375 L5,92.625 C5,87.861544 8.00228747,84 11.7057967,84 L23,84",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-11",
    x: 1,
    y: 23,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-12",
    x: 1,
    y: 48,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-13",
    x: 1,
    y: 52,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.992748,86 L18.2795052,86 C8.18401325,86 0,76.3741221 0,64.5 L0,10.75 C0,4.81293894 4.09200663,-1.36424205e-12 9.13975261,-1.36424205e-12 L23,-1.36424205e-12",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9639825,107 L11.7057967,107 C8.00228747,107 5,103.138456 5,98.375 L5,92.625 C5,87.861544 8.00228747,84 11.7057967,84 L23,84",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-16",
    x: 0,
    y: 23,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-17",
    x: 0,
    y: 48,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-18",
    x: 0,
    y: 52,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.992748,86 L18.2795052,86 C8.18401325,86 0,76.3741221 0,64.5 L0,10.75 C0,4.81293894 4.09200663,-1.36424205e-12 9.13975261,-1.36424205e-12 L23,-1.36424205e-12",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9639825,107 L11.7057967,107 C8.00228747,107 5,103.138456 5,98.375 L5,92.625 C5,87.861544 8.00228747,84 11.7057967,84 L23,84",
    id: "path-20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-21",
    x: 1,
    y: 23,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-22",
    x: 1,
    y: 48,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-23",
    x: 1,
    y: 52,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.992748,86 L18.2795052,86 C8.18401325,86 0,76.3741221 0,64.5 L0,10.75 C0,4.81293894 4.09200663,-1.36424205e-12 9.13975261,-1.36424205e-12 L23,-1.36424205e-12",
    id: "path-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9639825,107 L11.7057967,107 C8.00228747,107 5,103.138456 5,98.375 L5,92.625 C5,87.861544 8.00228747,84 11.7057967,84 L23,84",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-26",
    x: 0,
    y: 23,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-27",
    x: 0,
    y: 48,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-28",
    x: 0,
    y: 52,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.992748,86 L18.2795052,86 C8.18401325,86 0,76.3741221 0,64.5 L0,10.75 C0,4.81293894 4.09200663,-1.36424205e-12 9.13975261,-1.36424205e-12 L23,-1.36424205e-12",
    id: "path-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9639825,107 L11.7057967,107 C8.00228747,107 5,103.138456 5,98.375 L5,92.625 C5,87.861544 8.00228747,84 11.7057967,84 L23,84",
    id: "path-30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-31",
    x: 1,
    y: 23,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-32",
    x: 1,
    y: 48,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-33",
    x: 1,
    y: 52,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,101 C35.9783371,101 29.9458428,101 21.902517,101 C21.2490016,101.000034 20.6027328,100.867666 20.0053432,100.611457 C10.7801689,96.6549587 5.20247921,91.9325626 3.27227406,86.4442691 C0.281581441,77.940614 -2.27905025,59.8313315 3.27227406,57.2908536 C8.82359837,54.7503756 4.44017537,51.1890111 3.27227406,37.2210213 C2.54929034,28.574204 2.49764605,19.8095166 3.11734119,10.9269592 C3.20921184,9.61058821 3.89071997,8.398555 4.98338554,7.60834019 C8.84297161,4.81709081 12.5452734,2.47047881 16.1903658,0.5685042 C19.024365,-0.910249683 23.6216548,0.856519384 28.0394117,1.78846716 C30.4955225,2.30659595 34.4823853,2.54537419 40,2.5048019",
    id: "path-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.992748,84 L34.2795052,84 C24.1840133,84 16,75.9411255 16,66 L16,21 C16,16.0294373 20.0920066,12 25.1397526,12 L39,12",
    id: "path-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9639825,101 L26.7057967,101 C23.0022875,101 20,97.9779221 20,94.25 L20,89.75 C20,86.0220779 23.0022875,83 26.7057967,83 L38,83",
    id: "path-36"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-37",
    x: 18,
    y: 35,
    width: 22,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-38",
    x: 18,
    y: 65,
    width: 22,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-39",
    x: 18,
    y: 70,
    width: 22,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,100.969113 C35.9748412,100.969113 29.7216512,101.060179 21.6719299,100.929576 C19.2350474,100.890039 5.51876007,96.3104237 2.43526931,86.5428837 C1.02696012,82.081798 0.0552115414,76.6974232 0.0552115414,70.1767241 C0.0552115414,63.656025 -0.576723574,58.7413075 2.43526931,57.3983835 C7.99578974,54.9191758 4.4092644,51.173357 3.24034788,37.2096388 C2.51673569,28.5654657 2.46504651,19.8034586 3.08528033,10.9236176 C3.17723084,9.6076492 3.85933139,8.39598663 4.95294677,7.60601348 C8.81588785,4.8156177 12.5214079,2.46972332 16.1696689,0.568330346 C19.0061316,-0.909971319 23.6074177,0.856257451 28.0290147,1.78792022 C30.4872606,2.30589057 34.477589,2.54459579 40,2.5040359",
    id: "path-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.992748,84 L35.2795052,84 C25.1840133,84 17,75.9411255 17,66 L17,21 C17,16.0294373 21.0920066,12 26.1397526,12 L40,12",
    id: "path-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,101 L28.7418142,101 C25.0383049,101 22,96.6080223 22,92.8801002 L22,89.75 C22,86.0220779 25.0383049,83 28.7418142,83 L40,83",
    id: "path-42"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-43",
    x: 17,
    y: 35,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-44",
    x: 17,
    y: 65,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-45",
    x: 17,
    y: 70,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,106.968924 C35.9748412,106.968924 29.7216512,107.060547 21.6719299,106.929145 C19.2350474,106.889366 5.51876007,102.281754 2.43526931,92.4545009 C1.02696012,87.9661426 0.0552115414,82.5488507 0.0552115414,75.9882876 C0.0552115414,69.4277246 -0.576723574,64.4829612 2.43526931,63.1318273 C7.99578974,60.6374631 4.4092644,56.8687445 3.24034788,42.8196598 C2.51673569,34.122641 2.46504651,25.3070678 3.08528033,16.3729404 C3.17723084,15.0489269 3.85933139,13.8298569 4.95294677,13.0350543 C8.81588785,10.2275995 12.5168889,7.80462892 16.1696689,5.95434663 C24.0062815,1.98478221 31.9497252,1.35695087e-12 40,1.36424205e-12",
    id: "path-46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.992748,90 L34.2795052,90 C24.1840133,90 16,81.9411255 16,72 L16,27 C16,22.0294373 20.0920066,18 25.1397526,18 L39,18",
    id: "path-47"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-48",
    x: 17,
    y: 41,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-49",
    x: 17,
    y: 71,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-50",
    x: 17,
    y: 76,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,106.968924 C35.9748412,106.968924 29.7216512,107.060547 21.6719299,106.929145 C19.2350474,106.889366 5.51876007,102.281754 2.43526931,92.4545009 C1.02696012,87.9661426 0.0552115414,82.5488507 0.0552115414,75.9882876 C0.0552115414,69.4277246 -0.576723574,64.4829612 2.43526931,63.1318273 C7.99578974,60.6374631 4.4092644,56.8687445 3.24034788,42.8196598 C2.51673569,34.122641 2.46504651,25.3070678 3.08528033,16.3729404 C3.17723084,15.0489269 3.85933139,13.8298569 4.95294677,13.0350543 C8.81588785,10.2275995 12.5168889,7.80462892 16.1696689,5.95434663 C24.0062815,1.98478221 31.9497252,1.35695087e-12 40,1.36424205e-12",
    id: "path-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.992748,90 L35.2795052,90 C25.1840133,90 17,81.9411255 17,72 L17,27 C17,22.0294373 21.0920066,18 26.1397526,18 L40,18",
    id: "path-52"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-53",
    x: 17,
    y: 41,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-54",
    x: 17,
    y: 71,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-55",
    x: 17,
    y: 76,
    width: 23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-56",
    x: 105,
    y: 46,
    width: 23,
    height: 23,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-57",
    cx: 115,
    cy: 105,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-58",
    cx: 115,
    cy: 104,
    r: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-59",
    x: 108,
    y: 50,
    width: 14,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.384932,56 C113.026911,54.8175263 114.404345,54 116,54 C117.595655,54 118.973089,54.8175263 119.615068,56 L122,56 L122,57 L119.959492,57 C119.986187,57.1633015 120,57.3302393 120,57.5 C120,59.4329966 118.209139,61 116,61 C113.790861,61 112,59.4329966 112,57.5 C112,57.3302393 112.013813,57.1633015 112.040508,57 L108,57 L108,56 L112.384932,56 Z",
    id: "path-60"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-61",
    x: 108,
    y: 62,
    width: 14,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-62",
    x: 0,
    y: 14,
    width: 6,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-63",
    x: 2,
    y: 0,
    width: 2,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-64",
    x: 3,
    y: 27,
    width: 24,
    height: 22,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.182954,30 L184,30 C185.656854,30 187,31.3431458 187,33 L187,56 C187,57.6568542 185.656854,59 184,59 L168.394509,59 C167.32035,59 166.328162,58.425701 165.793133,57.4942704 L152.581578,34.4942704 C151.756316,33.0575702 152.251984,31.223887 153.688684,30.3986242 C154.143376,30.1374417 154.658586,30 155.182954,30 Z",
    id: "path-65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.707971,32.0723204 L195.911725,30.547177 C196.821754,30.4232968 197.738389,30.7230886 198.399344,31.3607695 L217.284162,49.5806004 C218.079081,50.3475279 218.101772,51.6136546 217.334845,52.4085734 C217.16308,52.5866068 216.959777,52.7312287 216.735255,52.8350976 L199.490274,60.8130147 C198.07529,61.4676179 196.394731,60.9292791 195.623468,59.5743489 L182.505424,36.5289928 C181.685785,35.089077 182.188618,33.2573457 183.628534,32.4377064 C183.961696,32.2480617 184.328118,32.1240289 184.707971,32.0723204 Z",
    id: "path-66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.473044,65.4430344 L184.9902,65.4904689 C185.736376,65.5137984 186.447046,65.8144993 186.983356,66.3338193 L201.116972,80.0196739 C201.910489,80.7880518 201.930868,82.0542178 201.162491,82.8477347 C200.839875,83.1809059 200.411499,83.3916029 199.950671,83.4437703 L190.09262,84.5597367 C188.707313,84.7165585 187.396537,83.8983764 186.928937,82.584976 L181.694473,67.8823359 C181.355988,66.9315954 181.852319,65.886472 182.80306,65.5479874 C183.017883,65.4715056 183.245124,65.4359083 183.473044,65.4430344 Z",
    id: "path-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,19 L48,19 C49.6568542,19 51,20.3431458 51,22 L51,40 C51,41.6568542 49.6568542,43 48,43 L44,43 C40.1340068,43 37,39.8659932 37,36 L37,22 C37,20.3431458 38.3431458,19 40,19 Z",
    id: "path-68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19050617,52 L46,52 C47.6568542,52 49,53.3431458 49,55 L49,89 C49,90.6568542 47.6568542,92 46,92 L23.499355,92 C22.2921355,92 21.202524,91.276389 20.734247,90.1636915 L6.42539821,56.1636915 C5.78270912,54.6365646 6.49968769,52.8775811 8.02681465,52.234892 C8.39519263,52.0798607 8.79083499,52 9.19050617,52 Z",
    id: "path-69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,19 L174,19 C175.656854,19 177,20.3431458 177,22 L177,40 C177,41.6568542 175.656854,43 174,43 L170,43 C166.134007,43 163,39.8659932 163,36 L163,22 C163,20.3431458 164.343146,19 166,19 Z",
    id: "path-70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-71",
    x: 139,
    y: 61,
    width: 48,
    height: 29,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,101.62098 L53,94 C53,93.4477153 53.4477153,93 54,93 L76,93 C76.5522847,93 77,93.4477153 77,94 L77,101.62098 C71.6072716,102.540327 67.6072716,103 65,103 C62.3927284,103 58.3927284,102.540327 53,101.62098 Z",
    id: "path-72"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-73",
    x: 16.1078585,
    y: 37.2582415,
    width: 1,
    height: 24,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5105673,70 L68.3752475,70 C68.9275322,70 69.3752475,70.4477153 69.3752475,71 C69.3752475,71.1171733 69.3546543,71.2334349 69.3144077,71.3434794 L67.8930766,75.2297602 C67.7033782,75.748444 67.9700735,76.3227013 68.4887574,76.5123998 C68.527042,76.5264016 68.5661469,76.5380494 68.6058532,76.5472778 L74.3441546,77.8809597 C74.714658,77.9670712 75.0042252,78.2559262 75.0912488,78.6262163 L75.9734778,82.3801464 C75.9911002,82.4551309 76,82.5319005 76,82.608928 L76,89 C76,89.5522847 75.5522847,90 75,90 L55,90 C54.4477153,90 54,89.5522847 54,89 L54,80.8532887 C54,80.6572625 54.0576136,80.4655592 54.1656786,80.3020103 L60.676246,70.4487216 C60.86137,70.1685493 61.1747587,70 61.5105673,70 Z",
    id: "path-74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8818515,69.0000481 L65.9050827,69.0000912 C66.4573436,69.0000912 66.9050395,69.4477872 66.9050395,70.0000481 C66.9050395,70.1680687 66.8627017,70.3333805 66.781936,70.4807163 C65.1598806,73.4397315 64.3488529,76.6058679 64.3488529,79.9791257 C64.3488529,83.4579423 65.2114335,86.9868268 66.9365946,90.5657794 L66.9365615,90.5657954 C67.1763638,91.0632799 66.967471,91.660969 66.4699865,91.9007713 C66.3345502,91.9660556 66.1861357,91.999959 66.035786,91.999959 L62.9468176,91.9999276 C62.5627917,91.9999276 62.2126913,91.780005 62.0459837,91.4340505 C60.0153279,87.2199987 59,83.3434884 59,79.8045194 C59,76.2778269 60.0082958,72.8378936 62.0248875,69.4847195 L62.0248466,69.4846949 C62.205699,69.1839747 62.530938,69.0000481 62.8818515,69.0000481 Z",
    id: "path-75"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-76",
    x: 64,
    y: 19,
    width: 82,
    height: 50,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-77",
    x: 74,
    y: 28,
    width: 63,
    height: 32,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-78",
    x: 61,
    y: 105,
    width: 90,
    height: 10,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1200---\\u0440\\u0435\\u0439\\u0442\\u0438\\u043D\\u0433-\\u0432-\\u043A\\u0430\\u0440\\u0442\\u043E\\u0447\\u043A\\u0435-\\u0430\\u0432\\u0442\\u043E-+-\\u0442\\u0430\\u0431-\\u0442\\u0435\\u0445-\\u0441\\u043E\\u0441\\u0442\\u043E\\u044F\\u043D\\u0438\\u0435-v1.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-968.000000, -1705.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "car-copy-2",
    transform: "translate(969.000000, 1706.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(122.000000, 36.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.07439043,142.460534 C1.22530589,144.029159 5.98992247,141.703903 6.63054319,141.442465 C9.51641633,140.264458 12.5917038,139.449388 15.5715141,138.53897 C21.5988926,136.693529 27.66785,134.986495 33.7953255,133.508604 C45.374237,130.718912 57.1333231,128.871932 68.9986659,127.853864 C83.7252427,126.589736 98.531897,126.382124 113.304672,126.322147 C130.584492,126.249867 147.844293,126.988044 165.047115,128.605881 C178.460111,129.866933 191.833069,131.613951 205.105929,133.925366 C212.568545,135.226403 220.081978,136.59203 227.398298,138.582031 C229.189264,139.069535 230.823155,139.806174 232.514024,140.576645 C233.478035,141.016476 234.482085,141.654691 235.082667,140.575108 C235.714048,139.443237 235.62781,137.210252 235.800285,135.933822 C236.63032,129.766971 236.993749,123.538606 236.999909,117.31793 C237.013769,104.06766 235.441476,90.8097 232.609501,77.8716167 C229.917662,65.5779001 226.073938,53.4687277 220.753398,42.0485202 C216.230554,32.3414975 210.588164,22.8297841 202.946914,15.2296406 C196.625404,8.93976059 189.533918,5.21504436 180.763882,3.74945618 C170.473912,2.03011979 160.016086,1.28732956 149.60754,0.772143789 C126.040089,-0.395098002 102.318643,-0.236697601 78.7696718,1.23196631 C70.9436274,1.71793259 62.9959266,2.20697461 55.2822988,3.6910172 C50.9919879,4.51531443 47.4115957,6.32384717 43.9051212,8.9151547 C31.4900149,18.0916129 22.4243078,31.9308868 15.8163667,45.6486691 C4.8595965,68.3921985 0.190457036,93.8054668 0.00566259806,118.931154 C-0.0513156869,126.786583 0.32289305,134.642013 1.07439043,142.460534 Z",
    id: "Stroke-9",
    stroke: "#B2B2B2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0290575,142.481483 C6.17360522,143.989194 10.7371831,141.754234 11.3507734,141.502949 C14.1148798,140.370687 17.0604082,139.587269 19.9144882,138.712205 C25.687547,136.938428 31.5004301,135.297683 37.3693624,133.877183 C48.4597122,131.195822 59.7226343,129.420567 71.0873298,128.442033 C85.192532,127.226995 99.374433,127.027445 113.523884,126.969797 C130.074598,126.900324 146.606137,127.609835 163.083102,129.164847 C175.930149,130.376928 188.738846,132.056105 201.451671,134.277761 C208.599408,135.528274 215.795819,136.84087 222.803433,138.753593 C224.518831,139.222166 226.083781,139.930199 227.703306,140.670751 C228.626641,141.093502 229.588326,141.706933 230.163567,140.669273 C230.768307,139.581356 230.685709,137.881976 230.850906,136.655113 C231.645919,130.72774 231.994013,124.74124 231.999913,118.762131 C232.013188,106.026408 230.507237,93.2832933 227.794754,80.8476337 C225.216495,69.0313182 221.534953,57.3923804 216.438909,46.4156529 C212.106902,37.0855824 206.702588,27.9432367 199.383753,20.638229 C193.328974,14.5926035 186.536706,11.0125289 178.136714,9.60385381 C168.28092,7.95128429 158.264353,7.23733878 148.294985,6.74215918 C125.721942,5.62024481 103.001401,5.77249406 80.446057,7.18412545 C72.9502254,7.65122024 65.3378706,8.12127132 57.9497123,9.54768419 C53.8404273,10.3399715 50.4111064,12.0782737 47.0525845,14.5689531 C35.1613223,23.3890626 26.4781345,36.6909169 20.1490095,49.8759975 C9.65455023,71.7363291 5.18242087,96.1627257 5.00542367,120.312709 C4.95084953,127.863089 5.30926887,134.966578 6.0290575,142.481483 Z",
    id: "Stroke-9-Copy",
    stroke: "#B2B2B2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22",
    x: 11,
    y: 133,
    width: 220,
    height: 291
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8844517,406.010389 C37.002754,410.808683 52.8194899,413.864528 68.4817049,416.184192 C100.020919,420.854387 131.872265,420.970139 163.443928,416.52836 C175.124145,414.884686 186.734828,412.696207 198.198717,409.92897 C201.646073,409.097101 205.079522,408.214302 208.492885,407.254334 C209.36129,407.008941 211.754815,405.798949 212.658761,406.028909 C213.187223,406.164725 213.924286,407.488924 214.256505,407.919521 C215.792441,409.91508 217.24339,412.007871 218.400749,414.24728 C219.879512,417.108662 220.098931,419.587292 219.96759,422.680177 C219.621463,430.745755 218.802503,438.81442 217.536979,446.788941 C215.982501,456.566101 213.874839,466.71984 209.287121,475.580247 C206.634,480.707275 203.430787,484.488497 197.966936,486.377565 C192.313025,488.33454 186.268176,489.243577 180.357761,490.027602 C172.107901,491.123385 163.799326,491.756161 155.492295,492.19756 C135.843446,493.243956 116.115792,493.223892 96.4607627,492.387393 C80.0970237,491.69134 63.4226982,490.752979 47.3556389,487.37766 C42.3754378,486.331264 37.1881788,485.104296 33.0346632,482.022214 C25.7042027,476.583428 21.788649,467.497691 19.2606907,459.01232 C16.6431105,450.222908 15.3173232,441.060003 14.6343419,431.93414 C14.2372237,426.638885 13.0489598,419.993194 15.5290165,415.069889 C17.1792973,411.791801 19.4770197,408.771453 21.8844517,406.010389 Z",
    id: "Stroke-11",
    stroke: "#B2B2B2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3486152,409 C41.4394601,413.372116 56.1812721,415.893232 70.7790648,418.006867 C100.174837,422.262261 129.861528,422.367732 159.287545,418.320466 C170.17396,416.822781 180.995568,414.82868 191.680358,412.307225 C194.893427,411.549242 198.093535,410.744851 201.274922,409.870147 C201.814513,409.721081 203.108766,409.431032 205.15768,409 C205.944026,409.722601 206.440413,410.214685 206.64684,410.476252 C208.078391,412.294569 209.430732,414.20148 210.509436,416.241989 C211.8877,418.849227 212.092208,421.107708 211.969793,423.925887 C211.647188,431.275092 210.883887,438.627109 209.704369,445.893344 C208.255535,454.80211 206.291112,464.054008 202.015181,472.127445 C199.542369,476.799098 196.55685,480.244477 191.464328,481.965761 C186.194664,483.74892 180.56063,484.577217 175.051894,485.291606 C167.362704,486.290063 159.618789,486.866637 151.876314,487.268832 C133.562823,488.222288 115.175884,488.204006 96.8566332,487.441804 C81.604993,486.807573 66.0638741,485.952556 51.0887508,482.877028 C46.44701,481.923572 41.6122832,480.805582 37.7410453,477.997246 C30.9087714,473.041525 27.2593233,464.762771 24.9031681,457.031059 C22.4634817,449.022311 21.2277964,440.673243 20.5912312,432.357926 C20.2211017,427.532988 19.1135936,421.477559 21.4251028,416.991534 C22.9632286,414.004602 25.1047951,411.51583 27.3486152,409 Z",
    id: "Stroke-11-Copy",
    stroke: "#B2B2B2",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(123.000000, 159.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.63729188,17.838622 C33.3075816,5.98932562 68.6443275,0.0432079133 108.64753,0.00026888453 C148.785434,-0.0428147327 189.647145,5.0915976 231.232661,15.4035059 L231.232661,15.4035078 C232.30476,15.6693549 232.958357,16.7539746 232.692509,17.8260739 C232.630742,18.075167 232.521611,18.3100445 232.371071,18.5178911 L215.181646,42.2508102 C214.747405,42.8503533 214.017512,43.1609988 213.28439,43.05829 L149.07122,34.0621625 C148.228634,33.944118 147.552963,33.3059211 147.387085,32.4714331 L144.689158,18.8988878 C144.509765,17.9964083 143.737766,17.332776 142.818583,17.2908887 L63.7010209,13.6854923 C63.4127265,13.6723547 63.1250037,13.7217643 62.8576087,13.8303284 L12.4821302,34.2830914 C12.0572843,34.4555815 11.5695619,34.3170345 11.2988432,33.9469557 L1.74384438,20.8850743 C1.09169066,19.9935648 1.28572688,18.7421785 2.17723642,18.0900248 C2.31889298,17.9864007 2.47357338,17.9018737 2.63729188,17.838622 Z",
    id: "Path",
    stroke: "#B2B2B2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9360161,37.0828285 C44.6239798,43.0276095 54.3119435,46 63.9999072,46 C73.6878685,46 83.3758297,43.027611 93.063791,37.082833 L93.0637948,37.0828392 C93.5345254,36.793987 93.681967,36.1782235 93.3931148,35.7074928 C93.3852361,35.6946533 93.3770683,35.6819934 93.3686176,35.6695228 C83.5790475,21.2231743 73.7894773,14 63.9999072,14 C54.2103322,14 44.4207571,21.2231815 34.6311821,35.6695444 L34.6312032,35.6695587 C34.321391,36.126745 34.4408613,36.7485201 34.8980476,37.0583323 C34.9105177,37.0667826 34.923177,37.0749501 34.9360161,37.0828285 Z",
    id: "Path-2",
    stroke: "#B2B2B2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.490597,34.4438023 L140.24637,40.5212135 C139.761676,40.9929586 139.07139,41.1877681 138.411583,41.0390191 L108.291565,34.2486645 C108.219051,34.2323168 108.147505,34.2119391 108.07726,34.1876263 L83.432039,25.6575905 C82.3882231,25.296312 81.8349171,24.157258 82.1961956,23.1134421 C82.3724461,22.604214 82.7467272,22.1876537 83.2342615,21.9581153 L95.5047183,16.1810001 C95.7995046,16.0422103 96.1237358,15.9775429 96.4492112,15.9926225 L142.838028,18.1418671 C143.768261,18.1849658 144.545659,18.8643831 144.712934,19.7804678 L147.063127,32.6513176 C147.182832,33.3068825 146.968152,33.9790055 146.490597,34.4438023 Z",
    id: "Path-3",
    stroke: "#B2B2B2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B2B2B2",
    strokeWidth: 1,
    d: "M55.2794265,44.0779318 C55.1873269,44.060473 55.0937935,44.0516859 55.0000537,44.0516859 C54.1716244,44.0516859 53.5000497,44.7232606 53.5000497,45.5516897 L53.5000537,54.4059466 C53.5000537,54.4913661 53.5073502,54.5766296 53.5218635,54.6608071 C53.6626191,55.4771935 54.438535,56.0248981 55.2549205,55.8841369 C58.3362614,55.3528735 61.4180638,55.087202 64.5000269,55.087202 C67.5819923,55.087202 70.6637971,55.3528739 73.7451405,55.8841382 C73.8293177,55.8986514 73.9145808,55.9059478 74,55.9059478 C74.8284271,55.9059478 75.5,55.234375 75.5,54.4059478 L75.5,45.5516853 C75.5,45.4579459 75.491213,45.3644129 75.4737542,45.2723137 C75.3194615,44.4583834 74.5345613,43.9236406 73.7206306,44.0779312 C70.6475727,44.6604753 67.5739066,44.951805 64.5000269,44.951805 C61.4261482,44.951805 58.3524832,44.6604755 55.2794265,44.0779318 Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#B2B2B2",
    fill: "#FFFFFF",
    cx: 62,
    cy: 66,
    rx: 30,
    ry: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    stroke: "#B2B2B2",
    fill: "#FFFFFF",
    cx: 63,
    cy: 66.5,
    rx: 23,
    ry: 5.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-6"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B2B2B2",
    strokeWidth: 1,
    d: "M47.1776939,19.2295073 L21.4658583,29.0276154 C20.8843023,29.2492312 20.5,29.8069392 20.5,30.4292903 L20.5,36.4788049 C20.5,37.2422711 21.1189116,37.8611827 21.8823778,37.8611827 C22.2410706,37.8611827 22.5739037,38.0478829 22.7608939,38.3539796 C23.0572904,38.8391707 22.9042421,39.4727725 22.419051,39.769169 L21.2180348,40.5028529 C20.7720334,40.7753089 20.5,41.2602668 20.5,41.7829039 L20.5,42.3305096 C20.5,42.9764013 21.0235987,43.5 21.6694904,43.5 L32.423435,43.5 C33.0693267,43.5 33.5929254,42.9764013 33.5929254,42.3305096 C33.5929254,42.261221 33.5965174,42.1919789 33.603687,42.1230622 C33.718257,41.021775 34.7039041,40.2218826 35.8051914,40.3364526 L42.8792762,41.0723894 C43.2464699,41.1105896 43.5967259,40.9088445 43.7479266,40.5720525 C43.9413634,40.1411817 43.748885,39.6350963 43.3179964,39.4416809 C38.2858061,37.1825095 35.6383696,35.8074509 35.109412,35.1277239 C34.2169792,33.9809196 37.9742809,29.1880176 47.1776939,19.2295073 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-10"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M151,278.5 L151,279.5 L134,279.5 L134,278.5 L151,278.5 Z M151,279.5 L134,279.5 L134,278.5 L151,278.5 L151,279.5 Z M98,278.5 L98,279.5 L82,279.5 L82,278.5 L98,278.5 Z M98,279.5 L82,279.5 L82,278.5 L98,278.5 L98,279.5 Z M41.2873563,278.5 L190.712644,278.5 C204.402153,278.5 215.5,267.385378 215.5,253.674419 L215.5,221.44186 C215.5,198.830126 197.19754,180.5 174.62069,180.5 L57.3793103,180.5 C34.8024599,180.5 16.5,198.830126 16.5,221.44186 L16.5,253.674419 C16.5,267.385378 27.5978466,278.5 41.2873563,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-2",
    transform: "translate(143.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M22.4927902,85.5 L22.4999578,0.5 L9.13975261,0.5 C4.38776852,0.5 0.5,5.07271804 0.5,10.75 L0.5,64.5 C0.5,76.114343 8.47977515,85.5 18.2795052,85.5 L22.4927902,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M22.4647649,106.5 L22.4992164,84.5 L11.7057967,84.5 C8.30987602,84.5 5.5,88.1140643 5.5,92.625 L5.5,98.375 C5.5,102.885936 8.30987602,106.5 11.7057967,106.5 L22.4647649,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 0.5,
    y: 23.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 0.5,
    y: 48.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 0.5,
    y: 52.5,
    width: 22,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(33.500000, 53.500000) scale(-1, 1) translate(-33.500000, -53.500000) translate(21.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M22.4927902,85.5 L22.4999578,0.5 L9.13975261,0.5 C4.38776852,0.5 0.5,5.07271804 0.5,10.75 L0.5,64.5 C0.5,76.114343 8.47977515,85.5 18.2795052,85.5 L22.4927902,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M22.4647649,106.5 L22.4992164,84.5 L11.7057967,84.5 C8.30987602,84.5 5.5,88.1140643 5.5,92.625 L5.5,98.375 C5.5,102.885936 8.30987602,106.5 11.7057967,106.5 L22.4647649,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 1.5,
    y: 23.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 1.5,
    y: 48.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 1.5,
    y: 52.5,
    width: 22,
    height: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-3",
    transform: "translate(91.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M22.4927902,85.5 L22.4999578,0.5 L9.13975261,0.5 C4.38776852,0.5 0.5,5.07271804 0.5,10.75 L0.5,64.5 C0.5,76.114343 8.47977515,85.5 18.2795052,85.5 L22.4927902,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M22.4647649,106.5 L22.4992164,84.5 L11.7057967,84.5 C8.30987602,84.5 5.5,88.1140643 5.5,92.625 L5.5,98.375 C5.5,102.885936 8.30987602,106.5 11.7057967,106.5 L22.4647649,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 0.5,
    y: 23.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 0.5,
    y: 48.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-18"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 0.5,
    y: 52.5,
    width: 22,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(33.500000, 53.500000) scale(-1, 1) translate(-33.500000, -53.500000) translate(21.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-19"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M22.4927902,85.5 L22.4999578,0.5 L9.13975261,0.5 C4.38776852,0.5 0.5,5.07271804 0.5,10.75 L0.5,64.5 C0.5,76.114343 8.47977515,85.5 18.2795052,85.5 L22.4927902,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M22.4647649,106.5 L22.4992164,84.5 L11.7057967,84.5 C8.30987602,84.5 5.5,88.1140643 5.5,92.625 L5.5,98.375 C5.5,102.885936 8.30987602,106.5 11.7057967,106.5 L22.4647649,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-21"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 1.5,
    y: 23.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-22"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 1.5,
    y: 48.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-23"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 1.5,
    y: 52.5,
    width: 22,
    height: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-4",
    transform: "translate(40.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M22.4927902,85.5 L22.4999578,0.5 L9.13975261,0.5 C4.38776852,0.5 0.5,5.07271804 0.5,10.75 L0.5,64.5 C0.5,76.114343 8.47977515,85.5 18.2795052,85.5 L22.4927902,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M22.4647649,106.5 L22.4992164,84.5 L11.7057967,84.5 C8.30987602,84.5 5.5,88.1140643 5.5,92.625 L5.5,98.375 C5.5,102.885936 8.30987602,106.5 11.7057967,106.5 L22.4647649,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-26"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 0.5,
    y: 23.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-27"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 0.5,
    y: 48.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-28"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 0.5,
    y: 52.5,
    width: 22,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(33.500000, 53.500000) scale(-1, 1) translate(-33.500000, -53.500000) translate(21.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M22.4927902,85.5 L22.4999578,0.5 L9.13975261,0.5 C4.38776852,0.5 0.5,5.07271804 0.5,10.75 L0.5,64.5 C0.5,76.114343 8.47977515,85.5 18.2795052,85.5 L22.4927902,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-30"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M22.4647649,106.5 L22.4992164,84.5 L11.7057967,84.5 C8.30987602,84.5 5.5,88.1140643 5.5,92.625 L5.5,98.375 C5.5,102.885936 8.30987602,106.5 11.7057967,106.5 L22.4647649,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-31"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 1.5,
    y: 23.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-32"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 1.5,
    y: 48.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-33"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 1.5,
    y: 52.5,
    width: 22,
    height: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(24.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-34"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M39.5,100.5 L39.5,3.00773786 C34.2092229,3.03066071 30.3596524,2.78893788 27.9362056,2.27769973 C27.547773,2.19575793 27.1416619,2.10405417 26.6962807,1.99845333 C26.2667614,1.89661336 25.8587955,1.79620176 25.2006453,1.63162318 C20.0242276,0.337195933 18.1357852,0.117376519 16.4216667,1.01178728 C12.8724736,2.86372253 9.20145812,5.17488654 5.27639088,8.01349185 C4.30308046,8.71738912 3.6976159,9.79416745 3.61612881,10.9617573 C2.99819869,19.8190153 3.04969239,28.5581457 3.7705354,37.1793604 C4.02175354,40.1839057 4.42894331,42.8628994 5.00314012,45.6366426 C5.25407893,46.8488398 6.07241692,50.4090868 6.02035959,50.1738546 C6.35263166,51.6752973 6.50519615,52.62546 6.51916648,53.4606976 C6.55308026,55.4882863 5.68500851,56.7365732 3.48033884,57.7455062 C-0.935853944,59.7665087 -0.0901141908,75.3766969 3.74395342,86.2783819 C5.61922958,91.6104918 11.0934248,96.2452634 20.2024229,100.151936 C20.7374674,100.381407 21.3166714,100.500031 21.902517,100.5 C32.6938128,100.5 32.9555822,100.5 39.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M38.4927984,83.5 L38.4999496,12.5 L25.1397526,12.5 C20.3664392,12.5 16.5,16.3073189 16.5,21 L16.5,66 C16.5,75.6632439 24.4584458,83.5 34.2795052,83.5 L38.4927984,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-36"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M37.464982,100.5 L37.4989985,83.5 L26.7057967,83.5 C23.2791679,83.5 20.5,86.2974876 20.5,89.75 L20.5,94.25 C20.5,97.7025124 23.2791679,100.5 26.7057967,100.5 L37.464982,100.5 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.16617621,58 L16.1450444,58 C15.9141038,65.9771315 16.4157768,71.2520458 17.6500633,73.8247426 C18.8843499,76.3974395 21.3343288,79.5026094 25,83.1402522 C22.7657145,84.5243868 21.3212198,86.4882268 20.6665162,89.0317724 C19.6844607,92.8470907 21.4943324,97.5170226 21.2318745,98.755216 C20.9694166,99.9934094 9.11585866,96.501062 4.57681536,89.0317724 C1.67545506,84.2573962 0.539189705,74.5515299 1.16801928,59.9141737 L1.16800361,59.914173 C1.21398022,58.8439688 2.09498486,58 3.16617621,58 Z",
    id: "Path-5",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-37"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 18.5,
    y: 35.5,
    width: 21,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-38"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 18.5,
    y: 65.5,
    width: 21,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-39"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 18.5,
    y: 70.5,
    width: 21,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(58.000000, 50.500000) scale(-1, 1) translate(-58.000000, -50.500000) translate(38.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-40"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M39.5,100.469344 L39.5,3.00696908 C34.2044635,3.02989985 30.3514621,2.78825569 27.9259247,2.27717726 C27.5371626,2.19526225 27.130706,2.10358822 26.6849447,1.99802135 C26.2550566,1.89621362 25.8467391,1.79583345 25.1880202,1.63130605 C20.0068473,0.337210812 18.1166397,0.117444255 16.4007563,1.01172478 C12.8484509,2.86310779 9.1742232,5.17357832 5.2457261,8.0113285 C4.27155495,8.7150211 3.66561172,9.79138551 3.58406511,10.9584564 C2.96560044,19.8129685 3.01713868,28.5493886 3.73860515,37.1679292 C3.95536863,39.7573563 4.2634998,42.1311763 4.67799618,44.627277 C4.8849705,45.8736781 5.52292515,49.3549767 5.58138123,49.6961009 C5.8626715,51.3375887 5.98101621,52.4038911 5.95571566,53.322807 C5.89550328,55.5097208 4.94960174,56.8247923 2.6388778,57.8550492 C0.744670163,58.6995986 0.421974889,60.6037352 0.52754527,67.3894201 C0.547468417,68.6700084 0.555211541,69.3634061 0.555211541,70.1767241 C0.555211541,76.1856113 1.38042134,81.5405609 2.9120746,86.3923622 C4.24119196,90.6025928 7.72274703,94.1751148 12.5454947,96.950882 C16.0199217,98.9506136 20.1711898,100.405161 21.6800411,100.429642 C26.4071508,100.506337 30.1630656,100.513468 35.9251036,100.484563 C38.1972461,100.473165 38.8384568,100.470101 39.5,100.469344 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-41"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M39.4927984,83.5 L39.4999496,12.5 L26.1397526,12.5 C21.3664392,12.5 17.5,16.3073189 17.5,21 L17.5,66 C17.5,75.6632439 25.4584458,83.5 35.2795052,83.5 L39.4927984,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-42"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M39.5,100.5 L39.5,83.5 L28.7418142,83.5 C25.3074852,83.5 22.5,86.3051769 22.5,89.75 L22.5,92.8801002 C22.5,96.6076164 25.542547,100.5 28.7418142,100.5 L39.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.22093911,58 L15.7631553,58 C15.625385,65.9263244 16.2052482,71.1676421 17.502745,73.7239532 C18.8002417,76.2802643 21.6326601,79.482776 26,83.3314883 C22.2357348,83.5598004 20.3536022,86.4057034 20.3536022,91.8691973 C20.3536022,100.064438 26.7049168,100.740262 20.1165031,99.5352027 C13.5280894,98.330143 8.53148733,96.2558447 3.75999092,88.8341278 C0.6439714,83.9873852 -0.535292583,74.025948 0.222198975,58.9498161 L0.222201795,58.9498162 C0.248937215,58.417709 0.688160671,58 1.22093911,58 Z",
    id: "Path-5",
    stroke: "#B1B1B1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-43"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 17.5,
    y: 35.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-44"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 17.5,
    y: 65.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-45"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 17.5,
    y: 70.5,
    width: 22,
    height: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-5",
    transform: "translate(167.500000, 120.500000) scale(-1, 1) translate(-167.500000, -120.500000) translate(128.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(58.000000, 53.500000) scale(-1, 1) translate(-58.000000, -53.500000) translate(38.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M39.5,106.469156 L39.5,0.502580014 C31.7010389,0.58309017 24.0012158,2.54783542 16.3956066,6.40038714 C13.0194649,8.11054087 9.45331752,10.382437 5.24689858,13.4395198 C4.27226422,14.147851 3.66573151,15.2318492 3.58407978,16.4075685 C2.96559376,25.3165199 3.01713383,34.1066614 3.73862616,42.7782018 C3.955404,45.3836319 4.2635554,47.772121 4.67807638,50.2836305 C4.88506058,51.5377112 5.52301889,55.0403126 5.58146641,55.3834721 C5.86269516,57.0346338 5.98100474,58.1071365 5.95571795,59.0311673 C5.89555914,61.2294935 4.95038433,62.5515881 2.63991456,63.5880294 C0.744963815,64.4380753 0.421957522,66.3556991 0.527546003,73.1840384 C0.547468686,74.4724255 0.555211541,75.170038 0.555211541,75.9882876 C0.555211541,82.0345217 1.38051284,87.4228059 2.91233658,92.3048118 C4.24180482,96.5418997 7.72364941,100.136561 12.5466375,102.929437 C16.0208349,104.941261 20.1717913,106.404591 21.6800907,106.429212 C26.407174,106.506376 30.1630701,106.51355 35.9250882,106.484469 C38.197241,106.473001 38.8384512,106.469918 39.5,106.469156 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-47"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M38.4927984,89.5 L38.4999496,18.5 L25.1397526,18.5 C20.3664392,18.5 16.5,22.3073189 16.5,27 L16.5,72 C16.5,81.6632439 24.4584458,89.5 34.2795052,89.5 L38.4927984,89.5 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,106.5 L37.5,89.5 L26.7418142,89.5 C23.3074852,89.5 20.5,92.3051769 20.5,95.75 L20.5,98.8801002 C20.5,102.607616 23.542547,106.5 26.7418142,106.5 L37.5,106.5 Z",
    id: "Rectangle-4",
    stroke: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.22093911,64 L16.7631553,64 C16.625385,71.9263244 17.2052482,77.1676421 18.502745,79.7239532 C19.8002417,82.2802643 22.6326601,85.482776 27,89.3314883 C23.2357348,89.5598004 21.3536022,92.4057034 21.3536022,97.8691973 C21.3536022,106.064438 27.7049168,106.740262 21.1165031,105.535203 C14.5280894,104.330143 9.53148733,102.255845 4.75999092,94.8341278 C1.6439714,89.9873852 0.464707417,80.025948 1.22219897,64.9498161 L1.2222018,64.9498162 C1.24893722,64.417709 1.68816067,64 2.22093911,64 Z",
    id: "Path-5",
    stroke: "#B1B1B1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-48"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 17.5,
    y: 41.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-49"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 17.5,
    y: 71.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-50"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 17.5,
    y: 76.5,
    width: 22,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-3",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-51"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M39.5,106.469156 L39.5,0.502580014 C31.7010389,0.58309017 24.0012158,2.54783542 16.3956066,6.40038714 C13.0194649,8.11054087 9.45331752,10.382437 5.24689858,13.4395198 C4.27226422,14.147851 3.66573151,15.2318492 3.58407978,16.4075685 C2.96559376,25.3165199 3.01713383,34.1066614 3.73862616,42.7782018 C3.955404,45.3836319 4.2635554,47.772121 4.67807638,50.2836305 C4.88506058,51.5377112 5.52301889,55.0403126 5.58146641,55.3834721 C5.86269516,57.0346338 5.98100474,58.1071365 5.95571795,59.0311673 C5.89555914,61.2294935 4.95038433,62.5515881 2.63991456,63.5880294 C0.744963815,64.4380753 0.421957522,66.3556991 0.527546003,73.1840384 C0.547468686,74.4724255 0.555211541,75.170038 0.555211541,75.9882876 C0.555211541,82.0345217 1.38051284,87.4228059 2.91233658,92.3048118 C4.24180482,96.5418997 7.72364941,100.136561 12.5466375,102.929437 C16.0208349,104.941261 20.1717913,106.404591 21.6800907,106.429212 C26.407174,106.506376 30.1630701,106.51355 35.9250882,106.484469 C38.197241,106.473001 38.8384512,106.469918 39.5,106.469156 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-52"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M39.4927984,89.5 L39.4999496,18.5 L26.1397526,18.5 C21.3664392,18.5 17.5,22.3073189 17.5,27 L17.5,72 C17.5,81.6632439 25.4584458,89.5 35.2795052,89.5 L39.4927984,89.5 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.5,106.5 L39.5,89.5 L28.7418142,89.5 C25.3074852,89.5 22.5,92.3051769 22.5,95.75 L22.5,98.8801002 C22.5,102.607616 25.542547,106.5 28.7418142,106.5 L39.5,106.5 Z",
    id: "Rectangle-4",
    stroke: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22093911,64 L15.7631553,64 C15.625385,71.9263244 16.2052482,77.1676421 17.502745,79.7239532 C18.8002417,82.2802643 21.6326601,85.482776 26,89.3314883 C22.2357348,89.5598004 20.3536022,92.4057034 20.3536022,97.8691973 C20.3536022,106.064438 26.7049168,106.740262 20.1165031,105.535203 C13.5280894,104.330143 8.53148733,102.255845 3.75999092,94.8341278 C0.6439714,89.9873852 -0.535292583,80.025948 0.222198975,64.9498161 L0.222201795,64.9498162 C0.248937215,64.417709 0.688160671,64 1.22093911,64 Z",
    id: "Path-5",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-53"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 17.5,
    y: 41.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-54"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 17.5,
    y: 71.5,
    width: 22,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-55"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 17.5,
    y: 76.5,
    width: 22,
    height: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-6"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-56"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 105.5,
    y: 46.5,
    width: 22,
    height: 22,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-57"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    cx: 115,
    cy: 105,
    r: 8.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-58"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    cx: 115,
    cy: 104,
    r: 2.5
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    stroke: "#B1B1B1",
    fill: "#FFFFFF",
    cx: 115,
    cy: 104,
    r: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-7"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-59"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 108.5,
    y: 50.5,
    width: 13,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-60"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M110.020254,56.5 L112.628881,56.5 L112.533958,57.0806657 C112.5114,57.2186565 112.5,57.3586276 112.5,57.5 C112.5,59.1409011 114.053256,60.5 116,60.5 C117.946744,60.5 119.5,59.1409011 119.5,57.5 C119.5,57.3586276 119.4886,57.2186565 119.466042,57.0806657 L119.371119,56.5 L119.493093,56.5 L119.317588,56.5 L119.175651,56.2385646 C118.607597,55.1922553 117.380959,54.5 116,54.5 C114.619041,54.5 113.392403,55.1922553 112.824349,56.2385646 L112.682412,56.5 L110.020254,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-7-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-61"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 108.5,
    y: 62.5,
    width: 13,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(115.500000, 89.500000) scale(1, -1) translate(-115.500000, -89.500000) translate(112.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-9"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-62"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 0.5,
    y: 14.5,
    width: 5,
    height: 17
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-8"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-63"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 2.5,
    y: 0.5,
    width: 1,
    height: 13
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-54",
    transform: "translate(0.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77,399.509424 C77,414.300707 67.4836323,427.884538 53.5679856,432.922261 C39.5907243,437.983085 23.5370526,433.57527 14.0745977,422.133742 C4.59981983,410.678352 3.32593895,394.008127 10.9815471,381.254419 C18.6587204,368.465288 33.9314277,361.730356 48.5587225,364.692001 C64.9158458,368.003253 77,382.837659 77,399.509424 Z",
    id: "Stroke-14",
    stroke: "#B2B2B2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,400.004265 C62,408.2739 56.7210205,415.879483 48.9670345,418.768425 C41.1246,421.688397 32.0625071,419.291289 26.6718033,412.900552 C21.2779959,406.502057 20.466442,397.127735 24.6980049,389.902277 C28.9652576,382.616309 37.5851079,378.737493 45.869785,380.369699 C55.1351543,382.194294 62,390.569433 62,400.004265 Z",
    id: "Stroke-16",
    stroke: "#B2B2B2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,90.5102841 C71,105.301501 61.4836323,118.883732 47.5679856,123.922972 C33.5907243,128.982233 17.5370526,124.575978 8.07459768,113.132961 C-1.40018017,101.677622 -2.67406105,85.0074709 4.98154713,72.2553596 C12.6587204,59.4647456 27.9314277,52.7313845 42.5587225,55.691476 C58.9158458,59.0027126 71,73.8370526 71,90.5102841 Z",
    id: "Stroke-18",
    stroke: "#B2B2B2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,91.0055129 C56,99.275274 50.7210205,106.880972 42.9670345,109.768406 C35.1246,112.688423 26.0625071,110.291278 20.6718033,103.900444 C15.2779959,97.5034039 14.466442,88.1273878 18.6980049,80.9033714 C22.9652576,73.617293 31.5851079,69.7384182 39.869785,71.3690972 C49.1351543,73.1937199 56,81.5705379 56,91.0055129 Z",
    id: "Stroke-20",
    stroke: "#B2B2B2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5831535,351.869067 C41.4486714,347.16388 41.3141893,342.457161 41.178179,337.751974 C40.8373892,325.83646 40.4950711,313.919413 40.1527531,302.005432 C39.7019324,286.250952 39.2495836,270.498004 38.7972347,254.743524 C38.3265474,238.309866 37.8543319,221.873141 37.3821163,205.437949 C36.9893675,191.731736 36.5966187,178.025522 36.2038698,164.319308 C35.9792236,156.515658 35.7561056,148.710475 35.5329876,140.905292 C35.5024235,139.844364 35.1662183,139.116125 35.9257364,138.72671 C36.7494392,138.302032 38.3937884,138.421616 39.31224,138.266769 C41.2652867,137.935613 43.2015232,137.506335 45.1148366,136.989669 C57.3038044,133.702631 68.7301975,126.716141 75.3366303,115.671447 C79.9472265,107.964385 81.8299758,98.9802224 81.8880476,90.0619846 C81.9063861,87.2180219 81.9980784,84.0643662 81.4188885,81.2709968 C80.7923242,78.2491906 79.4062417,75.1752579 78.174508,72.3573584 C76.0686407,67.5371865 73.4065066,62.9393191 70.0780748,58.862717 C62.1589135,49.1641142 50.1793099,42.8092756 37.5609164,42.8522034 C36.8625265,42.8537365 36.1656647,42.8752004 35.4703312,42.9426582 C35.1815003,36.3992443 34.9828336,29.8435652 35.001172,23.2924856 C35.0195105,17.1461532 34.7520745,8.72005127 39.2709785,3.89221374 C42.7583436,0.168232362 48.5181504,-0.268710698 53.2907365,0.111506421 C58.7326766,0.546916348 63.7574165,2.55992069 68.3634282,5.42688042 C71.4015009,7.31723408 74.3723325,10.0860733 77.8520567,11.116339 C80.3567856,11.8583756 83.0173915,11.2865168 85.5572692,11.8829058 C91.6425839,13.3117862 96.995888,17.4113853 99.4914477,23.1085096 C101.918238,28.6553867 103.344054,34.6729359 104.681234,40.5586356 C108.426866,57.0551525 110.827677,73.8598293 113.281975,90.5863162 C114.397565,98.1845261 115.478006,105.788868 116.668479,113.374813 C117.455504,118.38816 118.16612,123.484296 119.468151,128.397989 C120.467598,132.169497 123.013588,135.09165 125.408286,138.093525 C130.524719,144.512756 135.916228,150.712748 141.226742,156.969466 C147.434313,164.280979 153.629659,171.609358 159.55604,179.152375 C164.162052,185.016611 169.00952,191.052557 172.374629,197.750818 C174.223757,201.430338 174.830455,205.572865 175.400476,209.612672 C176.32504,216.154553 176.850743,222.756226 177.303092,229.345634 C178.49662,246.734435 179.008569,264.172295 179.386036,281.594825 C179.720713,296.956823 179.894928,312.321888 179.960641,327.686952 C179.97898,331.712961 180.020241,335.738969 179.988149,339.763445 C179.943831,345.19687 176.505368,350.377328 173.72709,354.821883 C164.207898,370.044366 152.242048,383.558938 142.458476,398.598978 C140.789675,401.162377 139.128516,403.7963 137.921234,406.617266 C136.718536,409.425967 136.313561,412.515231 135.998751,415.530905 C134.980966,425.275501 135.228535,435.139683 135.023756,444.921075 C134.924422,449.682987 134.785356,454.452566 134.342176,459.196081 C134.019725,462.656363 133.643786,466.311354 132.350924,469.569263 C129.488595,476.77499 119.419249,478.69754 112.805175,480.376321 C108.417697,481.492442 103.975203,482.45525 99.6733042,483.877998 C95.8145851,485.156631 93.1279997,486.873741 90.1128501,489.507664 C84.8649921,494.096333 77.3294103,495.850238 70.5044442,495.992819 C63.1950369,496.146133 54.0685931,493.866363 50.202233,487.042386 C46.3205908,480.192345 45.1255341,471.474948 43.8678209,463.818479 C43.2290309,459.930452 42.6895743,456.027094 42.2234716,452.117604 C42.0691229,450.825172 41.9239433,449.53274 41.7894613,448.238776 C41.7527843,447.893821 41.4089381,446.602922 41.5953791,446.290163 C41.7741792,445.994268 42.5275846,445.982003 42.9508975,445.893081 C44.508139,445.564991 46.0485702,445.167909 47.5767758,444.726367 C59.5349845,441.27375 71.2471521,434.938842 79.0792057,425.034799 C84.2705201,418.469922 87.354439,410.537489 88.2010649,402.214107 C89.2570549,391.834793 86.3718028,381.437081 80.9741807,372.560238 C73.8940042,360.916088 61.850216,353.622972 48.4249299,352.094438 C46.1662421,351.838405 43.8555952,351.697356 41.5831535,351.869067 Z",
    id: "Stroke-22",
    stroke: "#B1B1B1",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.533503,142 C131.399251,156.123377 140.374059,166.342046 145.457926,172.656007 C154.556347,183.955881 163.915156,197.740159 165.826129,200.714137 C170.768566,208.40606 172.144538,220.119366 172.570716,229.054397 C173.72201,253.163019 174.085334,277.35912 173.959627,301.495367 C173.909037,310.981356 174.471862,327.661587 172.570716,341.106709 C171.66979,347.478168 159.348411,356.466631 145.985648,366.069585 C138.389092,371.528739 127.985482,377.702428 114.774821,384.590649 L98.6957569,385 C97.8141685,377.469629 93.3640099,368.568361 85.3452811,358.296197 C73.317188,342.887953 54.6941977,343.549853 53.0385424,339.352445 C51.4309216,335.2773 49.4180742,273.659568 47,154.499246 L59.4302363,142.77729 L118.533503,142 Z",
    id: "Stroke-24",
    stroke: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.162654,273 L167.419318,273 C168.584612,313.663252 167.996051,336.025483 165.653632,340.086696 C162.140006,346.178514 152.286328,354.120358 140.569383,362.827871 C127.911001,372.235018 114.971321,378.606152 114.069492,378.995898 C112.332905,379.746401 113.256422,277.272681 113.162654,273 Z",
    id: "Stroke-26",
    stroke: "#B2B2B2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.500036,259.834254 C164.806191,259.783843 166.792564,259.765953 169.098719,259.718597 C171.404875,259.671241 168.975788,216.833314 165.311359,208.760591 C161.646931,200.687868 154.657176,192.259757 148.583833,184.340629 C141.526592,175.139837 134.15438,166.151383 126.41574,157.49442 C118.6771,148.837456 114.04395,142.882302 112.634942,144.17672 C111.695603,145.039665 111.798514,183.592177 112.943676,259.834254 C135.333537,260.055249 151.852324,260.055249 162.500036,259.834254 Z",
    id: "Stroke-28",
    stroke: "#B2B2B2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#B2B2B2",
    fillRule: "nonzero",
    x: 49,
    y: 267,
    width: 125,
    height: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(55.000000, 151.000000)",
    stroke: "#B1B1B1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0043511,2.00827901 L48.5690582,107.163214 C48.5644858,108.267774 47.6653563,109.15949 46.5607963,109.154918 C46.4724983,109.154552 46.3843214,109.14834 46.2968445,109.136321 L11.173644,104.310599 C5.81012743,103.573683 1.78025729,99.0436033 1.67306964,93.6307606 L0,9.14283258 L10.4038772,3.04018547e-14 L47.0043682,-8.8817842e-16 C48.1089377,-1.09108455e-15 49.0043682,0.8954305 49.0043682,2 C49.0043682,2.00275968 49.0043625,2.00551935 49.0043511,2.00827901 Z",
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.287275,16.9926076 L16.6671876,8.56311359 C17.1195354,7.69253369 18.1821307,7.33943292 19.0655648,7.76613198 L19.7696014,8.10620437 C20.3264452,8.37516017 20.7275539,8.88658135 20.8560715,9.49147433 C25.0175012,29.0780564 27.5185564,43.9142316 28.3592372,54 C29.1919033,63.9896146 29.2130372,79.1246474 28.4226391,99.4050983 L28.4226748,99.4050997 C28.3879607,100.295811 27.6557927,101 26.764405,101 L26.2830337,101 C25.590754,101 24.9477042,100.641995 24.583027,100.053554 L20.919265,94.1417387 C20.7437123,93.8584684 20.6417271,93.5358202 20.6225766,93.203113 L18.5162653,56.6094854 C18.5022182,56.36544 18.4435506,56.1260373 18.3431717,55.9031482 L16.3445107,51.4651694 C16.2626859,51.2834794 16.208473,51.0905813 16.1836683,50.8928662 L12.0775597,18.1637083 C12.0270504,17.7611059 12.1001924,17.3526631 12.287275,16.9926076 Z",
    id: "Path-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,8 L16.22013,8.10492086 L16.2201194,8.10494337 C17.0889527,8.51905647 17.7168521,9.3148679 17.9194708,10.2587329 C22.0381849,29.4450682 24.5166974,44.0005929 25.3550083,53.9253072 C26.1927901,63.8437566 26.2144238,78.8686542 25.4199094,99 L25.4198934,98.9999994",
    id: "Path-8-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6942005,16.093771 C35.6383522,16.1713028 35.200414,16.8184305 35.126401,16.9263267 C35.1036177,16.9595177 35.1036177,16.9595177 35.080774,16.9927001 C34.9037267,17.2496738 34.7607343,17.4502475 34.6457736,17.6002734 C34.573967,17.6939823 34.5131488,17.767935 34.4598484,17.8246432 C34.4209703,17.8660072 34.3842145,17.900557 34.3431084,17.9314164 C34.214938,18.0276372 34.0896169,18.081137 33.8877716,18.030175 C33.5798003,17.9524183 33.4902919,17.721612 33.5006191,17.4960377 C33.503661,17.4295926 33.5165097,17.3697067 33.5371881,17.3017503 C33.5644284,17.212229 33.6103272,17.0968454 33.6776283,16.9459257 C33.8101337,16.6487882 34.0339909,16.1964551 34.3589532,15.5710063 C35.4329011,13.5039987 36.677203,11.5499687 37.6484061,10.4883847 C38.2934306,9.78333362 38.835775,9.42330163 39.3714347,9.51254783 C40.0434334,9.62450943 40.3024412,10.3025674 40.3024412,11.4283265 C40.3024412,12.4435516 40.3149974,13.0749516 40.4010909,16.8546376 C40.4164184,17.5275468 40.4279216,18.0482215 40.438495,18.554711 C40.5489544,23.8459697 40.5289143,26.4340789 40.2687478,27.1064251 C40.0973716,27.549311 39.4970795,27.7211695 39.2497487,27.156663 C39.1956311,27.0331452 39.1632723,26.8686667 39.1320375,26.6176457 C39.0851251,26.2406297 39.0434142,25.6623798 38.9952829,24.777162 C38.9818475,24.5300629 38.8342893,21.5198373 38.7784544,20.5586205 C38.5758702,17.071067 38.2966937,14.877096 37.9728164,14.4931795 C37.8065422,14.296082 37.6676643,14.253577 37.4753682,14.3072685 C37.1788222,14.3900678 36.8013778,14.6952237 36.3999726,15.1609645 C36.256354,15.3276018 36.1170393,15.5055087 35.9742524,15.7006105 C35.8923844,15.8124736 35.6879022,16.1025146 35.6942005,16.093771 Z",
    id: "Path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-6",
    transform: "translate(56.000000, 275.000000)",
    stroke: "#B2B2B2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0050187,2.00953429 L46.7208826,61.6018819 C46.6899776,68.0847237 41.4095425,73.3150518 34.9267008,73.2841468 C32.1237835,73.2707847 29.4181653,72.2548893 27.2991235,70.4201726 C27.2991235,70.4201726 27.2991235,70.4201726 27.2991235,70.4201726 C21.3040459,65.2294919 15.0112886,61.2423673 8.42085166,58.4587989 L8.42085261,58.4587967 C4.47669556,56.7929237 1.85751829,52.9898341 1.7075246,48.7109313 L0,0 L45.0050414,-1.77635684e-15 C46.1096109,-1.97926296e-15 47.0050414,0.8954305 47.0050414,2 C47.0050414,2.00317811 47.0050339,2.00635622 47.0050187,2.00953429 Z",
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3228442,11.1222241 L19.1590822,6.68295573 C19.5380111,6.08985767 20.2836121,5.84773894 20.9386979,6.10506179 L21.1195734,6.17610731 C21.7151154,6.4100409 22.1627811,6.91479469 22.3239017,7.5340163 C25.2144035,18.6428493 26.9546203,27.0752089 27.5445519,32.8310951 C28.1328351,38.5708977 28.1512228,47.2493166 27.5997149,58.8663515 L27.599705,58.866351 C27.5695775,59.5009607 27.0462847,60 26.4109603,60 L25.9504627,60 C25.5137673,60 25.0890728,59.8570704 24.7412365,59.5930386 L22.7930882,58.1142596 C22.3313625,57.7637779 22.0444158,57.2302069 22.0065793,56.6517639 L20.5623771,34.5728475 C20.5431353,34.2786791 20.4591009,33.9924019 20.3162889,33.7345066 L19.0895085,31.51914 C18.9753143,31.3129238 18.8984745,31.0881438 18.8625362,30.8551763 L16.0316108,12.5039331 C15.9574625,12.023273 16.0609984,11.5320641 16.3228442,11.1222241 Z",
    id: "Path-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,6 C21.7633352,17.1737574 22.6446826,26.9693894 23.4106607,32.7493546 C24.1761554,38.5256713 24.1959225,47.2758864 23.4699619,59",
    id: "Path-8-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6942005,16.093771 C33.6383522,16.1713028 33.200414,16.8184305 33.126401,16.9263267 C33.1036177,16.9595177 33.1036177,16.9595177 33.080774,16.9927001 C32.9037267,17.2496738 32.7607343,17.4502475 32.6457736,17.6002734 C32.573967,17.6939823 32.5131488,17.767935 32.4598484,17.8246432 C32.4209703,17.8660072 32.3842145,17.900557 32.3431084,17.9314164 C32.214938,18.0276372 32.0896169,18.081137 31.8877716,18.030175 C31.5798003,17.9524183 31.4902919,17.721612 31.5006191,17.4960377 C31.503661,17.4295926 31.5165097,17.3697067 31.5371881,17.3017503 C31.5644284,17.212229 31.6103272,17.0968454 31.6776283,16.9459257 C31.8101337,16.6487882 32.0339909,16.1964551 32.3589532,15.5710063 C33.4329011,13.5039987 34.677203,11.5499687 35.6484061,10.4883847 C36.2934306,9.78333362 36.835775,9.42330163 37.3714347,9.51254783 C38.0434334,9.62450943 38.3024412,10.3025674 38.3024412,11.4283265 C38.3024412,12.4435516 38.3149974,13.0749516 38.4010909,16.8546376 C38.4164184,17.5275468 38.4279216,18.0482215 38.438495,18.554711 C38.5489544,23.8459697 38.5289143,26.4340789 38.2687478,27.1064251 C38.0973716,27.549311 37.4970795,27.7211695 37.2497487,27.156663 C37.1956311,27.0331452 37.1632723,26.8686667 37.1320375,26.6176457 C37.0851251,26.2406297 37.0434142,25.6623798 36.9952829,24.777162 C36.9818475,24.5300629 36.8342893,21.5198373 36.7784544,20.5586205 C36.5758702,17.071067 36.2966937,14.877096 35.9728164,14.4931795 C35.8065422,14.296082 35.6676643,14.253577 35.4753682,14.3072685 C35.1788222,14.3900678 34.8013778,14.6952237 34.3999726,15.1609645 C34.256354,15.3276018 34.1170393,15.5055087 33.9742524,15.7006105 C33.8923844,15.8124736 33.6879022,16.1025146 33.6942005,16.093771 Z",
    id: "Path-9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-54-Copy-2",
    transform: "translate(388.000000, 292.000000) scale(-1, 1) translate(-388.000000, -292.000000) translate(298.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77,399.509424 C77,414.300707 67.4836323,427.884538 53.5679856,432.922261 C39.5907243,437.983085 23.5370526,433.57527 14.0745977,422.133742 C4.59981983,410.678352 3.32593895,394.008127 10.9815471,381.254419 C18.6587204,368.465288 33.9314277,361.730356 48.5587225,364.692001 C64.9158458,368.003253 77,382.837659 77,399.509424 Z",
    id: "Stroke-14",
    stroke: "#B2B2B2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,400.004265 C61,408.2739 55.7210205,415.879483 47.9670345,418.768425 C40.1246,421.688397 31.0625071,419.291289 25.6718033,412.900552 C20.2779959,406.502057 19.466442,397.127735 23.6980049,389.902277 C27.9652576,382.616309 36.5851079,378.737493 44.869785,380.369699 C54.1351543,382.194294 61,390.569433 61,400.004265 Z",
    id: "Stroke-16",
    stroke: "#B2B2B2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,90.5102841 C71,105.301501 61.4836323,118.883732 47.5679856,123.922972 C33.5907243,128.982233 17.5370526,124.575978 8.07459768,113.132961 C-1.40018017,101.677622 -2.67406105,85.0074709 4.98154713,72.2553596 C12.6587204,59.4647456 27.9314277,52.7313845 42.5587225,55.691476 C58.9158458,59.0027126 71,73.8370526 71,90.5102841 Z",
    id: "Stroke-18",
    stroke: "#B2B2B2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,91.0055129 C55,99.275274 49.7210205,106.880972 41.9670345,109.768406 C34.1246,112.688423 25.0625071,110.291278 19.6718033,103.900444 C14.2779959,97.5034039 13.466442,88.1273878 17.6980049,80.9033714 C21.9652576,73.617293 30.5851079,69.7384182 38.869785,71.3690972 C48.1351543,73.1937199 55,81.5705379 55,91.0055129 Z",
    id: "Stroke-20",
    stroke: "#B2B2B2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5831535,351.869067 C41.4486714,347.16388 41.3141893,342.457161 41.178179,337.751974 C40.8373892,325.83646 40.4950711,313.919413 40.1527531,302.005432 C39.7019324,286.250952 39.2495836,270.498004 38.7972347,254.743524 C38.3265474,238.309866 37.8543319,221.873141 37.3821163,205.437949 C36.9893675,191.731736 36.5966187,178.025522 36.2038698,164.319308 C35.9792236,156.515658 35.7561056,148.710475 35.5329876,140.905292 C35.5024235,139.844364 35.1662183,139.116125 35.9257364,138.72671 C36.7494392,138.302032 38.3937884,138.421616 39.31224,138.266769 C41.2652867,137.935613 43.2015232,137.506335 45.1148366,136.989669 C57.3038044,133.702631 68.7301975,126.716141 75.3366303,115.671447 C79.9472265,107.964385 81.8299758,98.9802224 81.8880476,90.0619846 C81.9063861,87.2180219 81.9980784,84.0643662 81.4188885,81.2709968 C80.7923242,78.2491906 79.4062417,75.1752579 78.174508,72.3573584 C76.0686407,67.5371865 73.4065066,62.9393191 70.0780748,58.862717 C62.1589135,49.1641142 50.1793099,42.8092756 37.5609164,42.8522034 C36.8625265,42.8537365 36.1656647,42.8752004 35.4703312,42.9426582 C35.1815003,36.3992443 34.9828336,29.8435652 35.001172,23.2924856 C35.0195105,17.1461532 34.7520745,8.72005127 39.2709785,3.89221374 C42.7583436,0.168232362 48.5181504,-0.268710698 53.2907365,0.111506421 C58.7326766,0.546916348 63.7574165,2.55992069 68.3634282,5.42688042 C71.4015009,7.31723408 74.3723325,10.0860733 77.8520567,11.116339 C80.3567856,11.8583756 83.0173915,11.2865168 85.5572692,11.8829058 C91.6425839,13.3117862 96.995888,17.4113853 99.4914477,23.1085096 C101.918238,28.6553867 103.344054,34.6729359 104.681234,40.5586356 C108.426866,57.0551525 110.827677,73.8598293 113.281975,90.5863162 C114.397565,98.1845261 115.478006,105.788868 116.668479,113.374813 C117.455504,118.38816 118.16612,123.484296 119.468151,128.397989 C120.467598,132.169497 123.013588,135.09165 125.408286,138.093525 C130.524719,144.512756 135.916228,150.712748 141.226742,156.969466 C147.434313,164.280979 153.629659,171.609358 159.55604,179.152375 C164.162052,185.016611 169.00952,191.052557 172.374629,197.750818 C174.223757,201.430338 174.830455,205.572865 175.400476,209.612672 C176.32504,216.154553 176.850743,222.756226 177.303092,229.345634 C178.49662,246.734435 179.008569,264.172295 179.386036,281.594825 C179.720713,296.956823 179.894928,312.321888 179.960641,327.686952 C179.97898,331.712961 180.020241,335.738969 179.988149,339.763445 C179.943831,345.19687 176.505368,350.377328 173.72709,354.821883 C164.207898,370.044366 152.242048,383.558938 142.458476,398.598978 C140.789675,401.162377 139.128516,403.7963 137.921234,406.617266 C136.718536,409.425967 136.313561,412.515231 135.998751,415.530905 C134.980966,425.275501 135.228535,435.139683 135.023756,444.921075 C134.924422,449.682987 134.785356,454.452566 134.342176,459.196081 C134.019725,462.656363 133.643786,466.311354 132.350924,469.569263 C129.488595,476.77499 119.419249,478.69754 112.805175,480.376321 C108.417697,481.492442 103.975203,482.45525 99.6733042,483.877998 C95.8145851,485.156631 93.1279997,486.873741 90.1128501,489.507664 C84.8649921,494.096333 77.3294103,495.850238 70.5044442,495.992819 C63.1950369,496.146133 54.0685931,493.866363 50.202233,487.042386 C46.3205908,480.192345 45.1255341,471.474948 43.8678209,463.818479 C43.2290309,459.930452 42.6895743,456.027094 42.2234716,452.117604 C42.0691229,450.825172 41.9239433,449.53274 41.7894613,448.238776 C41.7527843,447.893821 41.4089381,446.602922 41.5953791,446.290163 C41.7741792,445.994268 42.5275846,445.982003 42.9508975,445.893081 C44.508139,445.564991 46.0485702,445.167909 47.5767758,444.726367 C59.5349845,441.27375 71.2471521,434.938842 79.0792057,425.034799 C84.2705201,418.469922 87.354439,410.537489 88.2010649,402.214107 C89.2570549,391.834793 86.3718028,381.437081 80.9741807,372.560238 C73.8940042,360.916088 61.850216,353.622972 48.4249299,352.094438 C46.1662421,351.838405 43.8555952,351.697356 41.5831535,351.869067 Z",
    id: "Stroke-22",
    stroke: "#B1B1B1",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.533503,142 C131.399251,156.123377 140.374059,166.342046 145.457926,172.656007 C154.556347,183.955881 163.915156,197.740159 165.826129,200.714137 C170.768566,208.40606 172.144538,220.119366 172.570716,229.054397 C173.72201,253.163019 174.085334,277.35912 173.959627,301.495367 C173.909037,310.981356 174.471862,327.661587 172.570716,341.106709 C171.66979,347.478168 159.348411,356.466631 145.985648,366.069585 C138.389092,371.528739 127.985482,377.702428 114.774821,384.590649 L98.6957569,385 C97.8141685,377.469629 93.3640099,368.568361 85.3452811,358.296197 C73.317188,342.887953 54.6941977,343.549853 53.0385424,339.352445 C51.4309216,335.2773 49.4180742,273.659568 47,154.499246 L59.4302363,142.77729 L118.533503,142 Z",
    id: "Stroke-24",
    stroke: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.162654,273 L168.419318,273 C169.584612,313.663252 168.996051,336.025483 166.653632,340.086696 C163.140006,346.178514 153.286328,354.120358 141.569383,362.827871 C128.911001,372.235018 115.971321,378.606152 115.069492,378.995898 C113.332905,379.746401 114.256422,277.272681 114.162654,273 Z",
    id: "Stroke-26",
    stroke: "#B2B2B2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.500036,259.834254 C163.806191,259.783843 165.792564,259.765953 168.098719,259.718597 C170.404875,259.671241 167.975788,216.833314 164.311359,208.760591 C160.646931,200.687868 153.657176,192.259757 147.583833,184.340629 C140.526592,175.139837 133.15438,166.151383 125.41574,157.49442 C117.6771,148.837456 113.04395,142.882302 111.634942,144.17672 C110.695603,145.039665 110.798514,183.592177 111.943676,259.834254 C134.333537,260.055249 150.852324,260.055249 161.500036,259.834254 Z",
    id: "Stroke-28",
    stroke: "#B2B2B2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#B2B2B2",
    fillRule: "nonzero",
    x: 49,
    y: 267,
    width: 125,
    height: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(55.000000, 151.000000)",
    stroke: "#B1B1B1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0043511,2.00827901 L48.5690582,107.163214 C48.5644858,108.267774 47.6653563,109.15949 46.5607963,109.154918 C46.4724983,109.154552 46.3843214,109.14834 46.2968445,109.136321 L11.173644,104.310599 C5.81012743,103.573683 1.78025729,99.0436033 1.67306964,93.6307606 L-5.82076054e-12,9.14283258 L10.4038772,3.04018547e-14 L47.0043682,-8.8817842e-16 C48.1089377,-1.09108455e-15 49.0043682,0.8954305 49.0043682,2 C49.0043682,2.00275968 49.0043625,2.00551935 49.0043511,2.00827901 Z",
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.287275,16.9926076 L17.6671876,8.56311359 C18.1195354,7.69253369 19.1821307,7.33943292 20.0655648,7.76613198 L20.7696014,8.10620437 C21.3264452,8.37516017 21.7275539,8.88658135 21.8560715,9.49147433 C26.0175012,29.0780564 28.5185564,43.9142316 29.3592372,54 C30.1919033,63.9896146 30.2130372,79.1246474 29.4226391,99.4050983 L29.4226748,99.4050997 C29.3879607,100.295811 28.6557927,101 27.764405,101 L27.2830337,101 C26.590754,101 25.9477042,100.641995 25.583027,100.053554 L21.919265,94.1417387 C21.7437123,93.8584684 21.6417271,93.5358202 21.6225766,93.203113 L19.5162653,56.6094854 C19.5022182,56.36544 19.4435506,56.1260373 19.3431717,55.9031482 L17.3445107,51.4651694 C17.2626859,51.2834794 17.208473,51.0905813 17.1836683,50.8928662 L13.0775597,18.1637083 C13.0270504,17.7611059 13.1001924,17.3526631 13.287275,16.9926076 Z",
    id: "Path-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,8 L18.198117,8.10492086 L18.1981075,8.10494337 C18.9800574,8.51905647 19.5451669,9.3148679 19.7275237,10.2587329 C23.4343664,29.4450682 25.6650277,44.0005929 26.4195075,53.9253072 C27.1735111,63.8437566 27.1929814,78.8686542 26.4779185,99 L26.477904,98.9999994",
    id: "Path-8-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6942005,16.093771 C35.6383522,16.1713028 35.200414,16.8184305 35.126401,16.9263267 C35.1036177,16.9595177 35.1036177,16.9595177 35.080774,16.9927001 C34.9037267,17.2496738 34.7607343,17.4502475 34.6457736,17.6002734 C34.573967,17.6939823 34.5131488,17.767935 34.4598484,17.8246432 C34.4209703,17.8660072 34.3842145,17.900557 34.3431084,17.9314164 C34.214938,18.0276372 34.0896169,18.081137 33.8877716,18.030175 C33.5798003,17.9524183 33.4902919,17.721612 33.5006191,17.4960377 C33.503661,17.4295926 33.5165097,17.3697067 33.5371881,17.3017503 C33.5644284,17.212229 33.6103272,17.0968454 33.6776283,16.9459257 C33.8101337,16.6487882 34.0339909,16.1964551 34.3589532,15.5710063 C35.4329011,13.5039987 36.677203,11.5499687 37.6484061,10.4883847 C38.2934306,9.78333362 38.835775,9.42330163 39.3714347,9.51254783 C40.0434334,9.62450943 40.3024412,10.3025674 40.3024412,11.4283265 C40.3024412,12.4435516 40.3149974,13.0749516 40.4010909,16.8546376 C40.4164184,17.5275468 40.4279216,18.0482215 40.438495,18.554711 C40.5489544,23.8459697 40.5289143,26.4340789 40.2687478,27.1064251 C40.0973716,27.549311 39.4970795,27.7211695 39.2497487,27.156663 C39.1956311,27.0331452 39.1632723,26.8686667 39.1320375,26.6176457 C39.0851251,26.2406297 39.0434142,25.6623798 38.9952829,24.777162 C38.9818475,24.5300629 38.8342893,21.5198373 38.7784544,20.5586205 C38.5758702,17.071067 38.2966937,14.877096 37.9728164,14.4931795 C37.8065422,14.296082 37.6676643,14.253577 37.4753682,14.3072685 C37.1788222,14.3900678 36.8013778,14.6952237 36.3999726,15.1609645 C36.256354,15.3276018 36.1170393,15.5055087 35.9742524,15.7006105 C35.8923844,15.8124736 35.6879022,16.1025146 35.6942005,16.093771 Z",
    id: "Path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-6",
    transform: "translate(56.000000, 275.000000)",
    stroke: "#B2B2B2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0050187,2.00953429 L46.7208826,61.6018819 C46.6899776,68.0847237 41.4095425,73.3150518 34.9267008,73.2841468 C32.1237835,73.2707847 29.4181653,72.2548893 27.2991235,70.4201726 C27.2991235,70.4201726 27.2991235,70.4201726 27.2991235,70.4201726 C21.3040459,65.2294919 15.0112886,61.2423673 8.42085166,58.4587989 L8.42085261,58.4587967 C4.47669556,56.7929237 1.85751829,52.9898341 1.7075246,48.7109313 L0,1.13686838e-13 L45.0050414,1.11910481e-13 C46.1096109,1.11707575e-13 47.0050414,0.8954305 47.0050414,2 C47.0050414,2.00317811 47.0050339,2.00635622 47.0050187,2.00953429 Z",
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3228442,11.1222241 L19.1590822,6.68295573 C19.5380111,6.08985767 20.2836121,5.84773894 20.9386979,6.10506179 L21.1195734,6.17610731 C21.7151154,6.4100409 22.1627811,6.91479469 22.3239017,7.5340163 C25.2144035,18.6428493 26.9546203,27.0752089 27.5445519,32.8310951 C28.1328351,38.5708977 28.1512228,47.2493166 27.5997149,58.8663515 L27.599705,58.866351 C27.5695775,59.5009607 27.0462847,60 26.4109603,60 L25.9504627,60 C25.5137673,60 25.0890728,59.8570704 24.7412365,59.5930386 L22.7930882,58.1142596 C22.3313625,57.7637779 22.0444158,57.2302069 22.0065793,56.6517639 L20.5623771,34.5728475 C20.5431353,34.2786791 20.4591009,33.9924019 20.3162889,33.7345066 L19.0895085,31.51914 C18.9753143,31.3129238 18.8984745,31.0881438 18.8625362,30.8551763 L16.0316108,12.5039331 C15.9574625,12.023273 16.0609984,11.5320641 16.3228442,11.1222241 Z",
    id: "Path-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,6 C22.7633352,17.1737574 23.6446826,26.9693894 24.4106607,32.7493546 C25.1761554,38.5256713 25.1959225,47.2758864 24.4699619,59",
    id: "Path-8-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6942005,16.093771 C33.6383522,16.1713028 33.200414,16.8184305 33.126401,16.9263267 C33.1036177,16.9595177 33.1036177,16.9595177 33.080774,16.9927001 C32.9037267,17.2496738 32.7607343,17.4502475 32.6457736,17.6002734 C32.573967,17.6939823 32.5131488,17.767935 32.4598484,17.8246432 C32.4209703,17.8660072 32.3842145,17.900557 32.3431084,17.9314164 C32.214938,18.0276372 32.0896169,18.081137 31.8877716,18.030175 C31.5798003,17.9524183 31.4902919,17.721612 31.5006191,17.4960377 C31.503661,17.4295926 31.5165097,17.3697067 31.5371881,17.3017503 C31.5644284,17.212229 31.6103272,17.0968454 31.6776283,16.9459257 C31.8101337,16.6487882 32.0339909,16.1964551 32.3589532,15.5710063 C33.4329011,13.5039987 34.677203,11.5499687 35.6484061,10.4883847 C36.2934306,9.78333362 36.835775,9.42330163 37.3714347,9.51254783 C38.0434334,9.62450943 38.3024412,10.3025674 38.3024412,11.4283265 C38.3024412,12.4435516 38.3149974,13.0749516 38.4010909,16.8546376 C38.4164184,17.5275468 38.4279216,18.0482215 38.438495,18.554711 C38.5489544,23.8459697 38.5289143,26.4340789 38.2687478,27.1064251 C38.0973716,27.549311 37.4970795,27.7211695 37.2497487,27.156663 C37.1956311,27.0331452 37.1632723,26.8686667 37.1320375,26.6176457 C37.0851251,26.2406297 37.0434142,25.6623798 36.9952829,24.777162 C36.9818475,24.5300629 36.8342893,21.5198373 36.7784544,20.5586205 C36.5758702,17.071067 36.2966937,14.877096 35.9728164,14.4931795 C35.8065422,14.296082 35.6676643,14.253577 35.4753682,14.3072685 C35.1788222,14.3900678 34.8013778,14.6952237 34.3999726,15.1609645 C34.256354,15.3276018 34.1170393,15.5055087 33.9742524,15.7006105 C33.8923844,15.8124736 33.6879022,16.1025146 33.6942005,16.093771 Z",
    id: "Path-9"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M154.335353,557.146518 C183.171973,564.382174 212.226128,568 241.497814,568 C270.791183,568 300.175464,564.376812 329.650656,557.130434 L329.650652,557.130412 C331.028842,556.791588 332,555.534219 332,554.088684 L332,542.128915 C332,540.400864 330.626127,539 328.931367,539 L319.855996,539 C318.204081,539 316.86494,540.365449 316.86494,542.049814 L316.86494,542.475501 L316.864919,542.475501 C316.864919,543.99655 315.792122,545.297246 314.32247,545.558055 C289.36167,549.987677 265.075797,552.202487 241.464851,552.202487 C217.900289,552.202487 194.494535,549.996369 171.247589,545.584134 L171.247595,545.584103 C169.794382,545.308285 168.740543,544.01527 168.740543,542.508058 L168.740543,542.398812 C168.740543,540.907191 167.554643,539.697995 166.091761,539.697995 L155.198101,539.697995 C153.517348,539.697995 152.149347,541.07664 152.129677,542.790294 L152.000193,554.07165 L152.000212,554.07165 C151.983528,555.525277 152.950936,556.799141 154.335353,557.146518 Z",
    id: "Path-4",
    stroke: "#B2B2B2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.34646,17.5299591 C183.850435,24.5099864 212.569338,28 241.503171,28 C270.458788,28 299.50423,24.504729 328.639498,17.5141867 L328.639494,17.5141728 C330.024201,17.1819347 331,15.9485409 331,14.5305346 L331,3.06908172 C331,1.37407469 329.619775,2.69475545e-14 327.91718,2.7258922e-14 L318.990898,2.7258922e-14 C317.357335,1.18541881e-14 316.03307,1.31836379 316.03307,2.94464794 L316.03307,3.31518123 L316.033102,3.31518123 C316.033102,4.80727014 314.955185,6.0831718 313.478591,6.33888736 C288.809214,10.6111147 264.80654,12.7472284 241.470573,12.7472284 C218.181227,12.7472284 195.048743,10.6196414 172.073121,6.36446753 L172.073123,6.36446684 C170.613027,6.09405157 169.554135,4.82568112 169.554135,3.34715368 L169.554135,3.28161072 C169.554135,1.841426 168.381409,0.673925593 166.934777,0.673925593 L156.209844,0.673925593 C154.521322,0.673925593 153.146994,2.02620903 153.127235,3.70709163 L153.000195,14.5138134 L153.000213,14.5138137 C152.983451,15.9397621 153.955492,17.1893399 155.34646,17.5299591 Z",
    id: "Path-4-Copy",
    stroke: "#B2B2B2",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(242.000000, 14.000000) scale(-1, 1) rotate(-180.000000) translate(-242.000000, -14.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.614231,150.326396 L297.606092,147.096656 C297.407639,147.032613 297.200392,147 296.991861,147 L183.306744,147 C183.085408,147 182.865607,147.036741 182.656303,147.108724 L173.349559,150.309464 C172.5421,150.587163 172,151.346864 172,152.200741 L172,164.721359 C194.833333,161.547589 217.666667,159.960703 240.5,159.960703 C263.333333,159.960703 286.166667,161.973802 309,166 L309,152.229741 C309,151.361815 308.440212,150.59295 307.614231,150.326396 Z",
    id: "Path-11",
    stroke: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(235.500000, 103.500000) rotate(-180.000000) translate(-235.500000, -103.500000) translate(124.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-18"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-64"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 3.5,
    y: 27.5,
    width: 23,
    height: 21,
    rx: 3
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    stroke: "#B1B1B1",
    fill: "#FFFFFF",
    cx: 202,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4-Copy",
    stroke: "#B1B1B1",
    fill: "#FFFFFF",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-11"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-65"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M155.182954,30.5 C154.745981,30.5 154.316639,30.6145347 153.937729,30.8321869 C152.740479,31.5199058 152.327422,33.0479752 153.015141,34.2452253 L166.226696,57.2452253 C166.672553,58.0214175 167.499376,58.5 168.394509,58.5 L184,58.5 C185.380712,58.5 186.5,57.3807119 186.5,56 L186.5,33 C186.5,31.6192881 185.380712,30.5 184,30.5 L155.182954,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-11",
    transform: "translate(199.689383, 45.627469) rotate(-134.000000) translate(-199.689383, -45.627469) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-66"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M184.775413,32.5677511 C184.458869,32.6108415 184.153517,32.7142022 183.875882,32.8722395 C182.675952,33.5552722 182.256924,35.0817149 182.939957,36.2816448 L196.058001,59.3270009 C196.70072,60.4561094 198.101186,60.904725 199.280339,60.3592224 L216.52532,52.3813053 C216.693712,52.3034036 216.846189,52.1949372 216.975013,52.0614121 C217.550208,51.465223 217.53319,50.515628 216.937001,49.9404324 L198.052183,31.7206014 C197.501387,31.1892007 196.737524,30.9393742 195.979167,31.0426077 L184.775413,32.5677511 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-11-Copy",
    transform: "translate(191.950848, 74.936716) rotate(-134.000000) translate(-191.950848, -74.936716) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M183.457419,65.9427902 C183.291864,65.937614 183.126802,65.9634709 182.97076,66.0190254 C182.280166,66.2648919 181.919644,67.0240426 182.165511,67.7146359 L187.399975,82.4172761 C187.789642,83.5117764 188.881955,84.1935948 190.036378,84.06291 L199.894429,82.9469436 C200.24005,82.9078181 200.561331,82.7497953 200.803293,82.4999169 C201.379577,81.9047792 201.364292,80.9551547 200.769154,80.3788713 L186.635539,66.6930167 C186.188613,66.2602501 185.596388,66.009666 184.974575,65.9902247 L183.457419,65.9427902 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-68"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M40,19.5 C38.6192881,19.5 37.5,20.6192881 37.5,22 L37.5,36 C37.5,39.5898509 40.4101491,42.5 44,42.5 L48,42.5 C49.3807119,42.5 50.5,41.3807119 50.5,40 L50.5,22 C50.5,20.6192881 49.3807119,19.5 48,19.5 L40,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-11"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-69"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M9.19050617,52.5 C8.85744686,52.5 8.52774488,52.5665506 8.22076323,52.6957434 C6.94815743,53.2313176 6.3506753,54.6971371 6.88624953,55.9697429 L21.1950983,89.9697429 C21.5853292,90.8969908 22.4933387,91.5 23.499355,91.5 L46,91.5 C47.3807119,91.5 48.5,90.3807119 48.5,89 L48.5,55 C48.5,53.6192881 47.3807119,52.5 46,52.5 L9.19050617,52.5 Z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    stroke: "#B1B1B1",
    fill: "#FFFFFF",
    cx: 43.5,
    cy: 29.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-12-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-70"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M166,19.5 C164.619288,19.5 163.5,20.6192881 163.5,22 L163.5,36 C163.5,39.5898509 166.410149,42.5 170,42.5 L174,42.5 C175.380712,42.5 176.5,41.3807119 176.5,40 L176.5,22 C176.5,20.6192881 175.380712,19.5 174,19.5 L166,19.5 Z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5-Copy",
    stroke: "#B1B1B1",
    fill: "#FFFFFF",
    cx: 169.5,
    cy: 29.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5-Copy-3",
    stroke: "#B1B1B1",
    fill: "#F7F7F7",
    cx: 49.5,
    cy: 4.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5-Copy-2",
    stroke: "#B1B1B1",
    fill: "#F7F7F7",
    cx: 163.5,
    cy: 4.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-13"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-71"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 139.5,
    y: 61.5,
    width: 47,
    height: 28,
    rx: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.1504553,100.956666 L93.1504553,94.5599747 C93.1504553,93.4554052 94.0458858,92.5599747 95.1504553,92.5599747 L111.931843,92.5599701 C112.910624,92.5599701 113.86788,92.2726944 114.684925,91.7337613 C119.597676,88.4932493 123.156491,85.8208951 125.36137,83.7166987 C127.750924,81.4362591 131.467937,76.8151252 136.512407,69.853297 L163.925537,55.6030138 C164.586335,55.2595083 165.001539,54.5772893 165.003059,53.8325423 C165.009911,50.475383 164.722798,48.2707485 164.141721,47.2186388 C163.566168,46.1765334 162.068634,45.1179651 159.649116,44.0429338 L159.64911,44.0429486 C159.054643,43.7788174 158.368857,43.8203021 157.810565,44.1541663 C125.086117,65.476049 121.03434,69.3059058 118.58357,71.83285 C116.599064,73.879038 114.552205,76.3552618 112.442991,79.2615214 L112.442991,79.2615216 C111.479854,80.5886169 109.927218,81.3591149 108.287843,81.3235206 L87.1302422,80.8641436 C83.8173145,80.7922129 81.0733445,83.41956 81.0014138,86.7324877 C81.0004713,86.7758954 81,86.819312 81,86.8627299 L81,101.006461 C81,102.11103 81.8954305,103.006461 83,103.006461 C83.0040729,103.006461 83.0081458,103.006449 83.0122186,103.006424 L91.1626739,102.956629 C92.2624542,102.94991 93.1504553,102.056467 93.1504553,100.956666 Z",
    id: "Path-10",
    stroke: "#B1B1B1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    stroke: "#B1B1B1",
    transform: "translate(120.002408, 79.983005) rotate(39.000000) translate(-120.002408, -79.983005) ",
    x: 113.831636,
    y: 80.0035793,
    width: 13,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15-Copy",
    stroke: "#B1B1B1",
    transform: "translate(122.002408, 77.983005) rotate(39.000000) translate(-122.002408, -77.983005) ",
    x: 115.831636,
    y: 78.0035793,
    width: 13,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15-Copy-2",
    stroke: "#B1B1B1",
    transform: "translate(123.470796, 74.362298) rotate(39.000000) translate(-123.470796, -74.362298) ",
    x: 117.697321,
    y: 74.3828724,
    width: 12,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15-Copy-4",
    stroke: "#B1B1B1",
    transform: "translate(126.470796, 72.362298) rotate(39.000000) translate(-126.470796, -72.362298) ",
    x: 120.697321,
    y: 72.3828724,
    width: 12,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15-Copy-5",
    stroke: "#B1B1B1",
    transform: "translate(128.939184, 70.741591) rotate(39.000000) translate(-128.939184, -70.741591) ",
    x: 123.563006,
    y: 70.7621655,
    width: 11,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15-Copy-6",
    stroke: "#B1B1B1",
    transform: "translate(130.407572, 67.120884) rotate(39.000000) translate(-130.407572, -67.120884) ",
    x: 125.428692,
    y: 67.1414586,
    width: 10,
    height: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-16"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-72"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M53.5,101.198557 C58.6571068,102.066545 62.4941347,102.5 65,102.5 C67.5058653,102.5 71.3428932,102.066545 76.5,101.198557 L76.5,94 C76.5,93.7238576 76.2761424,93.5 76,93.5 L54,93.5 C53.7238576,93.5 53.5,93.7238576 53.5,94 L53.5,101.198557 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.5,97.5 L77,97.5 L76.5,97 L76.5,98 L77,97.5 L65.5,97.5 Z M65.5,97.5 L54,97.5 L54.5,98 L54.5,97 L54,97.5 L65.5,97.5 Z",
    id: "Rectangle-17",
    stroke: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-6",
    stroke: "#B1B1B1",
    fill: "#FFFFFF",
    cx: 13,
    cy: 38,
    r: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-19",
    transform: "translate(16.517177, 49.230859) rotate(-14.000000) translate(-16.517177, -49.230859) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-73"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 16.6078585,
    y: 37.7582415,
    width: 1,
    height: 23,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-74"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M61.5105673,69.5 L68.3752475,69.5 C69.2036746,69.5 69.8752475,70.1715729 69.8752475,71 C69.8752475,71.17576 69.8443577,71.3501524 69.7839878,71.5152192 L68.3626567,75.4014999 C68.2678075,75.6608418 68.4011552,75.9479705 68.6604971,76.0428197 C68.6796394,76.0498206 68.6991918,76.0556445 68.719045,76.0602587 L74.4573464,77.3939406 C75.0131014,77.5231078 75.4474522,77.9563903 75.5779877,78.5118255 L76.4602166,82.2657555 C76.4866504,82.3782324 76.5,82.4933867 76.5,82.608928 L76.5,89 C76.5,89.8284271 75.8284271,90.5 75,90.5 L55,90.5 C54.1715729,90.5 53.5,89.8284271 53.5,89 L53.5,80.8532887 C53.5,80.5592494 53.5864204,80.2716944 53.748518,80.0263711 L60.2590853,70.1730824 C60.5367713,69.752824 61.0068544,69.5 61.5105673,69.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    d: "M62.8818515,69.5000481 C62.7063919,69.5000481 62.5437925,69.5920066 62.4533695,69.7424076 C60.4823591,73.0197895 59.5,76.3712364 59.5,79.8045194 C59.5,83.2622636 60.4964146,87.0665631 62.4964148,91.2169979 C62.579766,91.3899698 62.7548107,91.4999276 62.9468227,91.4999276 L66.035786,91.499959 C66.1109581,91.499959 66.1851626,91.4830079 66.2528783,91.450367 C66.5016138,91.3304691 66.6060662,91.0316197 66.4861903,90.7828876 C64.7294302,87.1383811 63.8488529,83.5358703 63.8488529,79.9791257 C63.8488529,76.5218463 64.6810542,73.2730513 66.3434904,70.2403718 C66.3838715,70.1667071 66.4050395,70.0840548 66.4050395,70.0000481 C66.4050395,69.7239295 66.1812012,69.5000912 65.9050756,69.5000912 L62.8818443,69.5000481 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-21",
    fill: "#B1B1B1",
    x: 61,
    y: 72,
    width: 5,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-21-Copy",
    fill: "#B1B1B1",
    x: 61,
    y: 76,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-21-Copy-2",
    fill: "#B1B1B1",
    x: 61,
    y: 78,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-21-Copy-3",
    fill: "#B1B1B1",
    x: 61,
    y: 82,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-21-Copy-6",
    fill: "#B1B1B1",
    x: 61,
    y: 85,
    width: 5,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-21-Copy-7",
    fill: "#B1B1B1",
    x: 61,
    y: 88,
    width: 5,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-14"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-76"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 64.5,
    y: 19.5,
    width: 81,
    height: 49,
    rx: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-14-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-77"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 74.5,
    y: 28.5,
    width: 62,
    height: 31,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-14-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-78"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#B1B1B1",
    strokeWidth: 1,
    x: 61.5,
    y: 105.5,
    width: 89,
    height: 9,
    rx: 4
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    stroke: "#B1B1B1",
    fill: "#FFFFFF",
    cx: 89.5,
    cy: 58.5,
    r: 3.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarSalonScheme);
export default __webpack_public_path__ + "static/media/car-salon-scheme.e1620e71471e8c05390f6da653c31cb5.svg";
export { ForwardRef as ReactComponent };